// Política de fortaleza de contraseñas. Se aplica a TODA contraseña NUEVA:
//   - Reset password tras un "olvidé mi contraseña".
//   - Alta manual de empleado desde el formulario.
//   - Alta masiva desde Excel (cada fila se valida antes de subir).
//
// Las contraseñas YA EXISTENTES de usuarios viejos NO se tocan aunque no
// cumplan estas reglas — solo aplicamos al cambio/alta.
//
// Reglas (todas obligatorias):
//   1. Mínimo 8 caracteres.
//   2. Al menos una letra minúscula.
//   3. Al menos una letra mayúscula.
//   4. Al menos un número.
//   5. Al menos un símbolo (cualquier carácter no alfanumérico).

export const PASSWORD_MIN_LENGTH = 8;

export const PASSWORD_RULES = [
  { key: 'length',  label: `Al menos ${PASSWORD_MIN_LENGTH} caracteres`, test: (p) => p.length >= PASSWORD_MIN_LENGTH },
  { key: 'lower',   label: 'Una letra minúscula',                         test: (p) => /[a-z]/.test(p) },
  { key: 'upper',   label: 'Una letra mayúscula',                         test: (p) => /[A-Z]/.test(p) },
  { key: 'digit',   label: 'Un número',                                   test: (p) => /\d/.test(p) },
  { key: 'symbol',  label: 'Un símbolo (! @ # $ % …)',                    test: (p) => /[^A-Za-z0-9]/.test(p) },
];

// Evalúa una contraseña y devuelve qué reglas cumple. Útil para pintar la
// guía visual con cada regla en verde/gris.
export const evaluatePassword = (password) => {
  const pwd = password || '';
  const results = PASSWORD_RULES.map((r) => ({ ...r, ok: r.test(pwd) }));
  const passed = results.filter((r) => r.ok).length;
  // Score 0..4 (clamp a 4 para encajar con la barra: muy débil → fuerte).
  // Si cumple las 5 reglas, score = 4 ("fuerte").
  const score = Math.min(4, Math.max(0, passed - 1));
  return {
    valid: passed === PASSWORD_RULES.length,
    score,
    results,
  };
};

// Etiqueta humana para el score. Sirve tanto para mostrar texto como para
// elegir color en la barra (correlaciona 1-a-1 con el índice).
export const PASSWORD_STRENGTH_LABELS = [
  { label: 'Muy débil', color: '#DC2626', bg: '#FEE2E2' },   // rojo
  { label: 'Débil',     color: '#EA580C', bg: '#FFEDD5' },   // naranja
  { label: 'Aceptable', color: '#CA8A04', bg: '#FEF3C7' },   // amarillo
  { label: 'Buena',     color: '#16A34A', bg: '#DCFCE7' },   // verde claro
  { label: 'Fuerte',    color: '#047857', bg: '#A7F3D0' },   // verde fuerte
];

// Mensaje compacto con la PRIMERA regla que falla — útil para validar al
// enviar formulario y mostrar el motivo concreto sin abrumar al usuario.
export const firstFailureMessage = (password) => {
  for (const rule of PASSWORD_RULES) {
    if (!rule.test(password || '')) return `La contraseña debe contener: ${rule.label.toLowerCase()}.`;
  }
  return null;
};

// Validador booleano simple. Si no necesitas detalle, basta con esto.
export const isPasswordValid = (password) => evaluatePassword(password).valid;
